import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

import { Kicker } from '../Typography'
import {
  sidebar,
  sidebarBackgroundImage,
  sidebarBtn,
  sidebarContent,
  sidebarItem,
  sidebarOpen,
  titleContainer,
} from './SideBarItem.module.css'

const SidebarItem = ({
  clickedItem,
  extraClassName,
  extraTitleClassname,
  faqSection,
  innerBtnClassName,
  isSidebarOpen,
  item = {},
  setClickedItem,
  setIsSidebarOpen,
}) => {
  const { items, title } = item

  const onClick = (itemTitle) => {
    setClickedItem(itemTitle)
    setIsSidebarOpen(!isSidebarOpen)
  }
  return (
    <li className={`${sidebarItem} ${extraClassName}`}>
      <button
        className={`${sidebarBtn} ${innerBtnClassName}`}
        onClick={() => onClick(title)}
        onKeyDown={() => onClick(title)}
        tabIndex="0"
        type="button"
      >
        <div className={`${titleContainer}`}>
          {title && (
            <Kicker
              extraClassName={`${extraTitleClassname}`}
              faqSection={faqSection}
            >
              {title}
            </Kicker>
          )}
        </div>
      </button>
      <div
        className={`${sidebar} ${
          isSidebarOpen && clickedItem === title ? sidebarOpen : ''
        }`}
      >
        <div className={sidebarBackgroundImage}>
          <StaticImage
            alt="background"
            className={sidebarBackgroundImage}
            quality={85}
            src="../../assets/images/newMobileMenu.webp"
          />
        </div>
        <div className={`${sidebarContent}`}>
          {items &&
            items.map((subItem, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <React.Fragment key={index}>{subItem}</React.Fragment>
            ))}
        </div>
      </div>
    </li>
  )
}

export default SidebarItem
